import { render } from "./TaskTypeListPage.vue?vue&type=template&id=12e24f44&ts=true"
import script from "./TaskTypeListPage.vue?vue&type=script&lang=ts"
export * from "./TaskTypeListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__